module.exports = __webpack_public_path__ + "static/img/logo_w@2x.e95fe40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_w@2x.png
// module id = GLQE
// module chunks = 1